export const currentLocale = localStorage.getItem('locale');
